import React from 'react';
import './SectionTitle.css';

const SectionTitle = ({ children, icon }) => {
  return (
    <div className="bts-section-title">
      <div className="bts-section-title__bar" />
      <span className="bts-section-title__text">{children}</span>
      {/* {icon && <span className="bts-section-title__icon">{icon}</span>} */}
    </div>
  );
};

export default SectionTitle;
